function noop() {
    return null;
}
function noTry(fn, handleErr = noop) {
    const result = [null, null];
    try {
        result[1] = fn();
    }
    catch (err) {
        result[0] = err;
        handleErr(err);
    }
    return result;
}
async function noTryAsync(fn, handleErr = noop) {
    const result = [null, null];
    try {
        result[1] = await fn();
    }
    catch (err) {
        result[0] = err;
        handleErr(err);
    }
    return result;
}
const useTry = noTry;
const useTryAsync = noTryAsync;

export { noTry, noTryAsync, useTry, useTryAsync };
